module.exports = __webpack_public_path__ + "img/pending-transaction.682f35ef.svg";